import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Stage } from '@core/stages-types';
import { TruncateComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-placement-stage-badge',
  imports: [TruncateComponent],
  templateUrl: './placement-stage-badge.component.html',
  styleUrl: './placement-stage-badge.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlacementStageBadgeComponent {
  public stage = input.required<Stage>();
  public isBig = input<boolean>(false);
}
